import { render, staticRenderFns } from "./InfoPix.vue?vue&type=template&id=b12e5a08&scoped=true"
import script from "./InfoPix.vue?vue&type=script&lang=js"
export * from "./InfoPix.vue?vue&type=script&lang=js"
import style0 from "./InfoPix.vue?vue&type=style&index=0&id=b12e5a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12e5a08",
  null
  
)

export default component.exports